module.exports = __webpack_public_path__ + "img/logo.98f325e1.png";